module.exports = __webpack_public_path__ + "employees-21b62107/free-cover-3afb766bab04848423d6efdb4f226321.svg";